import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const AutoApprovalToast = ({ on }) => (
  <PositiveToast className="aridhia-auto-approval-toast">
    {on && (<FormattedMessage id="toast.auto.approval.on" />)}
    {!on && (<FormattedMessage id="toast.auto.approval.off" />)}
  </PositiveToast>
);

export default AutoApprovalToast;
